module.exports = __webpack_public_path__ + "img/cooperation_4.70322d6b.jpg";